import { render, staticRenderFns } from "./ConfigurarAlertas.vue?vue&type=template&id=b95f1d5a&"
import script from "./ConfigurarAlertas.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarAlertas.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarAlertas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports